import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { queryKeys } from "django/queryKeys";
import { getEnvVar } from "ideas.env";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { getRequestHeaders } from "utils/getRequestHeaders";

const getIsOnboarded = async () => {
  const headers = await getRequestHeaders();
  const response = await axios.get<{ onboarded: boolean }>(
    getEnvVar("URL_ONBOARD"),
    {
      headers,
    },
  );
  return response.data.onboarded;
};

export const useGetOnboardedStatus = () => {
  const hasPersonalSpace = useUserContext((s) => s.personalSpace !== undefined);
  const { data, isInitialLoading } = useQuery({
    queryKey: queryKeys.onboarded,
    queryFn: getIsOnboarded,
    enabled: !hasPersonalSpace,
    refetchOnWindowFocus: false,
  });

  return { isOnboarded: hasPersonalSpace ? true : data, isInitialLoading };
};
